module.exports = __webpack_public_path__ + "img/bank4.624e8181.png";